import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import api from "../../utils/api";

function View() {
  const [payslip, setPayslip] = useState([]);
  const { payid } = useParams();

  useEffect(() => {
    api
      .get(`/payslip/${payid}`)
      .then((response) => {
        setPayslip(response.data); // response.data is an array
      })
      .catch((error) => {
        console.error("Error fetching payslip data:", error);
      });
  }, []);

  const handleDownload = async (payid) => {
    try {
      const response = await api.get(`/payslip/download/${payid}`, {
        responseType: "blob", // Important for binary data like PDFs
      });

      // Create a blob from the PDF stream
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${payslip.employeeId}_payslip_${payslip.salaryPeriod}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };
  return (
    <div className="h-full w-full p-6">
      <div className="bg-white shadow rounded-lg p-6 min-h-full">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Payslip for {payslip.salaryPeriod}</h1>
          <button
            onClick={handleDownload}
            className="bg-slate-800 text-white px-6 py-2.5 rounded-full hover:bg-slate-700 flex items-center gap-2 transition-colors"
          >
            <span>Download</span>
            <MdOutlineFileDownload size={20} />
          </button>
        </div>

        <div className="space-y-6">
          <table className="w-full border border-slate-200">
            <tbody>
              <tr className="border">
                <td className="bg-slate-100 p-2 font-semibold">Employee ID</td>
                <td className="p-2">{payslip.employeeId}</td>
                <td className="bg-slate-100 p-2 font-semibold">Name</td>
                <td className="p-2">{payslip.name}</td>
                <td className="bg-slate-100 p-2 font-semibold">Email ID</td>
                <td className="p-2">{payslip.email}</td>
              </tr>
              <tr className="border">
                <td className="bg-slate-100 p-2 font-semibold">Base Location</td>
                <td className="p-2">{payslip.location}</td>
                <td className="bg-slate-100 p-2 font-semibold">Designation</td>
                <td className="p-2">{payslip.designation}</td>
                <td className="bg-slate-100 p-2 font-semibold">PAN No.</td>
                <td className="p-2">{payslip.pan}</td>
              </tr>
              <tr className="border">
                <td className="bg-slate-100 p-2 font-semibold">Date of Joining</td>
                <td className="p-2">{payslip.doj}</td>
                <td className="bg-slate-100 p-2 font-semibold">Bank Name</td>
                <td className="p-2">{payslip.bankName}</td>
                <td className="bg-slate-100 p-2 font-semibold">IFSC Code</td>
                <td className="p-2">{payslip.ifsccode}</td>
              </tr>
              <tr className="border">
                <td className="bg-slate-100 p-2 font-semibold">Bank A/C No.</td>
                <td className="p-2">{payslip.accountNumber}</td>
                <td className="bg-slate-100 p-2 font-semibold">UAN No.</td>
                <td className="p-2">{payslip.uanno}</td>
                <td className="bg-slate-100 p-2 font-semibold">Salary Period</td>
                <td className="p-2">{payslip.salaryPeriod}</td>
              </tr>
            </tbody>
          </table>

          <table className="w-full border border-slate-200">
            <tbody>
              <tr>
                <td className="bg-slate-100 p-2 font-semibold">Total Working Days</td>
                <td className="p-2">{payslip.totalWorkingDays}</td>
                <td className="bg-slate-100 p-2 font-semibold">Worked Days</td>
                <td className="p-2">{payslip.totalPresentDays}</td>
                <td className="bg-slate-100 p-2 font-semibold">Loss of Pay</td>
                <td className="p-2">{payslip.lopDays}</td>
              </tr>
            </tbody>
          </table>

          <table className="w-full border border-slate-200">
            <thead className="bg-slate-100">
              <tr>
                <th className="border p-2">Earnings</th>
                <th className="border p-2">Amount</th>
                <th className="border p-2">Deductions</th>
                <th className="border p-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr><td className="border p-2">Basic & DA</td><td className="border p-2">{payslip.basic != null ? `₹${payslip.basic}` : 'N/A'}</td><td className="border p-2">Provident Fund</td><td className="border p-2">₹{payslip.pf}</td></tr>
              <tr><td className="border p-2">HRA</td><td className="border p-2">{payslip.hra != null ? `₹${payslip.hra}` : 'N/A'}</td><td className="border p-2">Professional Tax</td><td className="border p-2">₹{payslip.pt}</td></tr>
              <tr><td className="border p-2">Special Allowance</td><td className="border p-2">{payslip.sp_al != null ? `₹${payslip.sp_al}` : 'N/A'}</td><td className="border p-2">ESI</td><td className="border p-2">₹{payslip.esi}</td></tr>
              <tr><td className="border p-2">Conveyance</td><td className="border p-2">{payslip.conveyance != null ? `₹${payslip.conveyance}` : 'N/A'}</td><td className="border p-2">TDS</td><td className="border p-2">₹{payslip.incomeTax}</td></tr>
              <tr><td className="border p-2">CCA</td><td className="border p-2">{payslip.cca != null ? `₹${payslip.cca}` : 'N/A'}</td><td className="border p-2">Labour Welfare Fund</td><td className="border p-2">₹{payslip.lwf}</td></tr>
              <tr><td className="border p-2">Bonus/Gratuity</td><td className="border p-2">{payslip.bonus != null ? `₹${payslip.bonus}` : 'N/A'}</td><td className="border p-2">Other Deductions</td><td className="border p-2">₹{payslip.otherDeductions}</td></tr>
              <tr><td className="border p-2">Internet Reimbursement</td><td className="border p-2">{payslip.internet != null ? `₹${payslip.internet}` : 'N/A'}</td><td className="border p-2"></td><td className="border p-2"></td></tr>
            </tbody>
            <tfoot className="bg-slate-100 font-semibold">
              <tr><td className="border p-2">Total Earnings</td><td className="border p-2">₹{payslip.total}</td><td className="border p-2">Total Deductions</td><td className="border p-2">₹{payslip.deductions}</td></tr>
            </tfoot>
          </table>

          <div className="bg-slate-50 p-4 rounded-lg space-y-2">
            <div className="text-right font-bold text-xl">
              Net Pay: ₹{payslip.netPayable}
            </div>
            <div className="text-right text-sm text-slate-600">
              Net Pay in Words: {payslip.netPayInWords} only
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
